export default __webpack_public_path__ + "static/871-55f8388f912ff9f6c7b046aaaec702b5.gif";